import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import colors from 'styles/colors'
import { type AnalyticsContentStoriesCard } from 'types/api/analytic'

interface StoriesAnalyticsCardDropdownProps {
    card: AnalyticsContentStoriesCard
}
export function StoriesAnalyticsCardDropdown({
    card
}: StoriesAnalyticsCardDropdownProps) {
    const { t } = useTranslation()
    return (
        <DropdownWrapper>
            <InfoContainer>
                <InfoType>{t('overallRevenue')}</InfoType>
                <InfoValue>{'$' + card.overall_revenue}</InfoValue>
            </InfoContainer>

            <InfoContainer>
                <InfoType>{t('tips')}</InfoType>
                <InfoValue>{card.tips ? `$${card.tips}` : '0'}</InfoValue>
            </InfoContainer>
            <InfoContainer>
                <InfoType>{t('mediaViews')}</InfoType>
                <InfoValue>{card.media_views}</InfoValue>
            </InfoContainer>

            <InfoContainer>
                <InfoType>{t('likes')}</InfoType>
                <InfoValue>{card.like_count}</InfoValue>
            </InfoContainer>
        </DropdownWrapper>
    )
}

const DropdownWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0.5rem 2.5rem;
`

const InfoContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: 'Montserrat';
    font-style: normal;
    margin: 1rem 0;
`
const InfoType = styled.div`
    font-weight: 500;
    font-size: 1.2rem;
    color: #828c94;
`
const InfoValue = styled.div`
    font-weight: 700;
    font-size: 1.4rem;
    color: $blue-dark;
    transition: all ease-in-out 0.3s;
    &:hover {
        color: ${colors.blueLighter};
    }
`
